import React, { useEffect, useId, useRef, useState } from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';
import { FunnelStage } from '../../../../types';

interface DealStageSelectorProps {
    currentStage: string;
    status: 'active' | 'won' | 'lost';
    stages: FunnelStage[];
    onStageChange: (stageId: string) => void;
    onWin: () => void;
    onLose: () => void;
}

export const DealStageSelector: React.FC<DealStageSelectorProps> = ({
    currentStage,
    status,
    stages,
    onStageChange,
    onWin,
    onLose
}) => {
    const isFinalized = status === 'won' || status === 'lost';
    const stageSelectId = useId();
    const [saved, setSaved] = useState(false);
    const savedTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => () => {
        if (savedTimer.current) clearTimeout(savedTimer.current);
    }, []);

    const flashSaved = () => {
        setSaved(true);
        if (savedTimer.current) clearTimeout(savedTimer.current);
        savedTimer.current = setTimeout(() => setSaved(false), 1400);
    };

    const handleStageChange = (stageId: string) => {
        onStageChange(stageId);
        flashSaved();
    };

    return (
        <div className="space-y-2">
            <div className="flex items-center justify-between gap-2">
                <label htmlFor={stageSelectId} className="text-body-sm text-muted">Etapa</label>
                {saved && <span className="chat-saved-flash" role="status">✓ Salvo</span>}
            </div>

            <select
                id={stageSelectId}
                name="dealStage"
                value={isFinalized ? status : currentStage}
                onChange={(e) => handleStageChange(e.target.value)}
                className="input-brand"
                disabled={isFinalized}
            >
                {stages.map(stage => (
                    <option key={stage.id} value={stage.id}>{stage.name}</option>
                ))}
            </select>

            {!isFinalized && (
                <div className="flex gap-2">
                    <button type="button" className="btn-success flex-1" onClick={onWin}>
                        <AppIcon name="check" className="h-3.5 w-3.5" aria-hidden="true" />
                        Ganho
                    </button>
                    <button type="button" className="btn-danger flex-1" onClick={onLose}>
                        <AppIcon name="x" className="h-3.5 w-3.5" aria-hidden="true" />
                        Perdido
                    </button>
                </div>
            )}
        </div>
    );
};

export default DealStageSelector;
